import { Component, Vue } from 'vue-property-decorator'
import { Spinner } from '@kwixeo/interface-vue'
import { mapActions } from 'vuex'

@Component({
  components: {
    Spinner
  },
  methods: {
    ...mapActions('auth', ['setToken']),
  }
})
export default class RegisterLogin extends Vue {
  setToken!: (token: KwixeoFramework.AuthToken|null) => void

  async mounted (): Promise<void> {
    this.setToken({
      access_token: this.$route.params.token,
      expires_at: this.$route.params.expire
    })
    await Vue.prototype.$kwInterface.goToHome(this.$router, this.$store)
  }
}
